import styled from 'styled-components'
import tw from 'twin.macro'

export const StyledLabel = styled.span`
  ${tw`text-base leading-6 font-medium font-inter text-lightBlueGray500`};
  ${(props) => props.css}
`
